export default "__VITE_ASSET__9b6fba53__"